<template>
    <a href="javascript:;" @click="removeCompareItem" class="remove-from-compare">
        <img :src="src" alt="" class="mCS_img_loaded">
    </a>
</template>

<script>
    import {mapGetters} from 'vuex';

    /**
     * Компонент для удаления товара из списка сравнения на странице сравнения товаров
     *
     * @vuedoc
     * @module vue:components/ComparePageDeleteItem
     * @exports vue:components/ComparePageDeleteItem
     */

    export default {
        name: "compare-page-delete-item",

        components: {
        },


        props: [
            'product_id','src'
        ],

        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {string|int} productId - Id товара за который отвечает компонент
         */
        data() {
            return {
                productId : this.product_id,
            }
        },

        computed: {
        },

        mounted(){
        },

        methods: {

            /**
             * Удаляет товар из списка для сравнения
             *
             * @method removeCompareItem
             */
            removeCompareItem(){
                this.$store.dispatch('compare/removeCompareItem',this.productId);
            },
        }
    }


</script>
